import React, { useState } from "react";

import { motion, useInView } from "framer-motion";
import { useRef } from "react";

import { SiFacebook, SiInstagram, SiLinkedin, SiTiktok } from "react-icons/si";

import Logo from "../../../images/whitelogo.png";
import { Link } from "react-router-dom";

import { useStateValue } from "../../../context/StateProvider.js";
import content from "../../../language/index.js";
import CookieSetting from "./CookiesPolicy.jsx";

const Footer = () => {
  const [{ language }, dispatch] = useStateValue();
  const [isOpen, setIsOpen] = useState(false);

  const togglePopup = () => setIsOpen(!isOpen);
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, margin: "-100px" });

  const handleCookieChoice = (choice) => {
    localStorage.setItem("cookieConsent", choice); // 'yes' or 'no'
    setIsOpen(false);
  };

  const containerVariants = {
    hidden: { opacity: 0, y: 100 },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.8,
        ease: "easeOut",
        staggerChildren: 0.2,
      },
    },
  };

  const itemVariants = {
    hidden: { opacity: 0, y: 50 },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.6,
        ease: "easeOut",
      },
    },
  };

  const socialVariants = {
    hidden: { scale: 0, rotate: -180 },
    visible: {
      scale: 1,
      rotate: 0,
      transition: {
        duration: 0.8,
        ease: "easeOut",
        delay: 0.3,
      },
    },
  };

  return (
    <div className="bg-themegray flex flex-col">
      {/* Animated Footer */}
      {/* <motion.footer
        ref={ref}
        variants={containerVariants}
        initial="hidden"
        animate={isInView ? "visible" : "hidden"}
        className=" bg-themeColor text-white"
      > */}
      <footer className=" bg-themeColor text-white text-center md:text-left">
        {/* Main Footer Content */}
        <div className="px-6 py-5 3xl:py-10 4xl:py-12">
          <div className="max-w-7xl 3xl:max-w-[85%] mx-auto">
            <div className="grid grid-cols-1 md:grid-cols-4 gap-8 md:gap-12 ">
              {/* Logo and Social Media Section */}
              {/* <motion.div variants={itemVariants} className="lg:col-span-1"> */}
              <div className="md:col-span-1 flex justify-center">
                <div className="space-y-8">
                  {/* Logo */}
                  <Link to={"/"}>
                    <img loading="lazy"
                      src={Logo}
                      className="h-14 md:h-12 4xl:h-24 5xl:h-32 w-auto object-contain"
                      alt="logo"
                    />
                  </Link>

                  {/* Social Media Icons */}
                  <motion.div
                    variants={socialVariants}
                    className="flex space-x-3"
                  >
                    <motion.a
                      href="https://www.linkedin.com/company/105676145/admin/dashboard/"
                      target="_blank"
                      whileHover={{ scale: 1.1 }}
                      whileTap={{ scale: 0.95 }}
                      className="w-9 h-9 4xl:w-14 4xl:h-14 rounded-lg bg-[#0A66C2] flex items-center justify-center transition-transform duration-300"
                    >
                      <SiLinkedin className="w-5 h-5 4xl:w-8 4xl:h-8 text-white" />
                    </motion.a>
                    <motion.a
                      href="https://www.instagram.com/raftekgroup/?igsh=cWttODd5djhjdWs0&utm_source=qr#"
                      target="_blank"
                      whileHover={{ scale: 1.1 }}
                      whileTap={{ scale: 0.95 }}
                      style={{
                        background:
                          "radial-gradient(circle at 30% 107%, #fdf497 0%, #fdf497 5%, #fd5949 45%, #d6249f 60%, #285AEB 90%)",
                      }}
                      className="w-9 h-9 4xl:w-14 4xl:h-14 rounded-lg flex items-center justify-center transition-transform duration-300"
                    >
                      <SiInstagram className="w-5 h-5 4xl:w-8 4xl:h-8 text-white" />
                    </motion.a>
                    <motion.a
                      href="https://www.facebook.com/profile.php?id=61575406075595&mibextid=wwXIfr&rdid=1DaeWcaABdMkLxxY#"
                      target="_blank"
                      whileHover={{ scale: 1.1 }}
                      whileTap={{ scale: 0.95 }}
                      className="w-9 h-9 4xl:w-14 4xl:h-14 rounded-lg bg-[#1877F2] flex items-center justify-center transition-transform duration-300"
                    >
                      <SiFacebook className="w-5 h-5 4xl:w-8 4xl:h-8 text-white" />
                    </motion.a>
                    <motion.a
                      href="https://www.tiktok.com/@raftek.group?_t=ZN-8wIhf6Qmx0A&_r=1"
                      target="_blank"
                      whileHover={{ scale: 1.1 }}
                      whileTap={{ scale: 0.95 }}
                      className="w-9 h-9 4xl:w-14 4xl:h-14 rounded-lg bg-black flex items-center justify-center transition-transform duration-300"
                    >
                      <SiTiktok className="w-5 h-5 4xl:w-8 4xl:h-8 text-white" />
                    </motion.a>
                  </motion.div>
                </div>
              </div>
              {/* </motion.div> */}

              {/* Contact Information */}
              <motion.div variants={itemVariants} className="md:col-span-1">
                <h3 className="text-lg PoppinsRegular mb-4 4xl:mb-7 text-White 4xl:text-3xl 5xl:text-4xl">
                  {content[language].info}
                </h3>
                <div className="space-y-2 text-sm 4xl:text-2xl 5xl:text-3xl text-White">
                  <div>
                    <p className="PoppinsRegular">Raftek Group Oy</p>
                  </div>
                  <div className="PoppinsRegular">
                    <span>{content[language].address}:</span> Koivupuistontie
                    12, FI-01510 Vantaa
                  </div>
                  <div className="PoppinsRegular">
                    <span>{content[language].email}:</span>{" "}
                    <a
                      href="mailto:info@raftekgroup.com"
                      className="text-white hover:text-blue-200 transition-colors"
                    >
                      info@raftekgroup.com
                    </a>
                  </div>
                  <div className="PoppinsRegular">
                    <span>{content[language].phone}:</span>{" "}
                    <a
                      href="tel:+358456637729"
                      className="text-white hover:text-blue-200 transition-colors"
                    >
                      +358 45 663 7729
                    </a>
                  </div>
                </div>
              </motion.div>

              {/* Services */}
              <motion.div variants={itemVariants} className="md:col-span-1">
                <h3 className="text-lg 4xl:text-3xl 5xl:text-4xl PoppinsRegular mb-4 4xl:mb-7 text-white">
                  {content[language].services}
                </h3>
                <ul className="space-y-2 text-sm 4xl:text-2xl 5xl:text-3xl text-white PoppinsRegular">
                  <li>
                    <Link
                      to={"/logistic-service"}
                      className="hover:text-blue-200 transition-colors duration-200"
                    >
                      {content[language].logistics}
                    </Link>
                  </li>
                  <li>
                    <Link
                      to={"/staff-service"}
                      className="hover:text-blue-200 transition-colors duration-200"
                    >
                      {content[language].staffing}
                    </Link>
                  </li>
                  <li>
                    <Link
                      to={"/cleaning-service"}
                      className="hover:text-blue-200 transition-colors duration-200"
                    >
                      {content[language].cleaning}
                    </Link>
                  </li>
                  <li>
                    <Link
                      to={"/security-service"}
                      className="hover:text-blue-200 transition-colors duration-200"
                    >
                      {content[language].security}
                    </Link>
                  </li>
                </ul>
              </motion.div>

              {/* Partner Logos */}
              <motion.div variants={itemVariants} className="md:col-span-1">
                <div className="space-y-2">
                  <motion.div
                    whileHover={{ scale: 1.05 }}
                    className="bg-white p-3 rounded-lg"
                  >
                    <div className="text-themegreen font-bold text-sm">
                      <img loading="lazy"
                        src="/website/footer1.webp"
                        alt=""
                        className="w-[110px] 4xl:w-w-[160px]"
                      />
                    </div>
                  </motion.div>
                  <motion.div
                    whileHover={{ scale: 1.05 }}
                    className="bg-[#1D9B5E] p-3 rounded-lg"
                  >
                    <div className="text-white font-bold text-xs">
                      <img loading="lazy"
                        src="/website/footer2.webp"
                        alt=""
                        className="w-[100px] 4xl:w-[150px]"
                      />
                    </div>
                  </motion.div>
                  <motion.div
                    whileHover={{ scale: 1.05 }}
                    className="bg-white p-3 rounded-lg"
                  >
                    <div className="text-blue-600 font-bold text-sm">
                      <img loading="lazy"
                        src="/website/footer3.webp"
                        alt=""
                        className="w-[110px] 4xl:w-[160px]"
                      />
                    </div>
                  </motion.div>
                </div>
              </motion.div>
            </div>
          </div>
        </div>

        {/* Bottom Footer */}
        <motion.div
          variants={itemVariants}
          className="border-t border-slate-700 px-6 py-3"
        >
          <div className="max-w-7xl 3xl:max-w-[85%] mx-auto flex sm:justify-center">
            <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
              <div className="flex flex-wrap gap-6 text-sm 4xl:text-2xl 5xl:text-3xl text-white PoppinsRegular">
                <motion.p className="hover:text-blue-200 transition-colors duration-200">
                  <Link to={"/privacy-policy"}>
                    {content[language].privacy}
                  </Link>
                </motion.p>
                <motion.p
                  onClick={togglePopup}
                  className="hover:text-blue-200 transition-colors duration-200 cursor-pointer"
                >
                  {content[language].cookie}
                </motion.p>
                {/* <motion.a
                  href="#"
                  className="hover:text-blue-200 transition-colors duration-200"
                >
                  {content[language].raftek}
                </motion.a> */}
                <motion.div className="hover:text-blue-200 transition-colors duration-200">
                  <a
                    href="https://apps.apple.com/pk/app/raftek/id6503914044"
                    target="_blank"
                    rel="noreferrer"
                  >
                    iOS
                  </a>{" "}
                  /{" "}
                  <a
                    href="https://play.google.com/store/apps/details?id=com.raftek&hl=en"
                    target="_blank"
                    rel="noreferrer"
                  >
                    Android
                  </a>
                </motion.div>
              </div>
              {/* <motion.a
                href="#"
                whileHover={{ scale: 1.05 }}
                className="text-blue-400 hover:text-blue-300 transition-colors duration-200 "
              >
                Login
              </motion.a> */}
            </div>
          </div>
        </motion.div>
      </footer>
      {/* </motion.footer> */}
      {isOpen && (
        <CookieSetting
          onUserChoice={handleCookieChoice}
          toggleModal={() => {
            setIsOpen(false);
          }}
        />
      )}
    </div>
  );
};

export default Footer;
